export default {
  check_status: {
    verified: 'Bekræftet',
    pending: 'Afventer',
    failed: 'Mislykkedes',
    not_applicable: 'Ikke nødvendig',
    required: 'Påkrævet',
  },
  records: {
    type: 'Type',
    name: 'Navn',
    value: 'Værdi',
    status: 'Status',
    certificate: 'Certifikat',
    certificate_hint: 'Udstedes automatisk, når posterne ovenfor er fundet.',
    full_name: 'Fuldt navn:',
  },
  check_hint: {
    found: 'Fandt {{values}} i stedet. Erstat den med den viste værdi.',
    missing: 'Denne post kunne ikke findes.',
    certificate: 'Certifikatet kunne ikke udstedes. Ret posterne markeret ovenfor, og tjek igen.',
    certificate_unknown: 'Certifikatet kunne ikke udstedes. Tjek igen senere, og kontakt support, hvis det fortsætter.',
    regressed: 'Denne post blev tidligere verificeret og kan ikke længere findes.',
    technical: 'Teknisk detalje: {{error}}',
    held_by_another_project:
      '{{name}} bruges af en anden hjemmeside på Vercel og kan derfor ikke videresende besøgende til shoppen på www.{{name}}. Hvis {{name}} også skal åbne shoppen, skal du først fjerne domænet fra den anden hjemmeside.',
    certificate_pending: {
      not_attached: 'I gang: domænet bliver tilføjet hos os.',
      awaiting_dns: 'I gang: certifikatet udstedes, når posterne ovenfor er fundet.',
      awaiting_certificate:
        'I gang: posterne peger på os, og certifikatet bliver udstedt. Det tager normalt nogle minutter.',
    },
    certificate_failed: {
      ownership_proof_required:
        '{{name}} er også forbundet til en anden Vercel-konto. For at bevise, at det er dit, skal du også tilføje TXT-posterne nedenfor hos DNS-udbyderen og derefter tjekke igen.',
      held_by_another_project:
        'En anden hjemmeside på Vercel bruger allerede {{name}}. Fjern først domænet fra den hjemmeside, og tjek derefter igen – eller brug et andet domæne.',
      dns_correct_but_unconfigured:
        'Posterne ovenfor er korrekte, men noget andet på {{name}} blokerer certifikatet. Fjern evt. AAAA-poster, slå evt. proxy fra foran domænet (f.eks. den orange sky hos Cloudflare), og sørg for, at ingen CAA-post udelukker Let’s Encrypt. Tjek derefter igen.',
      name_mismatch:
        '{{name}} svarer med et certifikat til {{names}}. Sørg for, at posterne ovenfor er de eneste på {{name}}. Hvis de er, så kontakt support.',
      name_mismatch_unnamed:
        '{{name}} svarer med et certifikat til et andet navn. Sørg for, at posterne ovenfor er de eneste på {{name}}. Hvis de er, så kontakt support.',
      expired:
        'Certifikatet er udløbet og blev ikke fornyet. Vi er blevet underrettet og arbejder på det – du skal ikke gøre noget lige nu.',
      expiring:
        'Certifikatet udløber snart og er endnu ikke fornyet. Vi arbejder på det – du skal ikke gøre noget lige nu.',
      attach_refused:
        'Vores hostingudbyder afviste at tilføje {{name}} hos os. Vi er blevet underrettet og undersøger sagen – du skal ikke ændre noget hos DNS-udbyderen lige nu.',
    },
    certificate_overdue: {
      not_attached: 'Efter 48 timer kunne domænet stadig ikke tilføjes hos os. Kontakt support.',
      awaiting_dns: 'Venter stadig på posterne ovenfor efter 48 timer. Ret posterne markeret ovenfor, og tjek igen.',
      awaiting_dns_records_verified:
        'Stadig ikke udstedt efter 48 timer, selvom posterne ovenfor er verificeret. Kontakt support.',
      awaiting_certificate:
        'Posterne peger på os, men certifikatet er stadig ikke udstedt efter 48 timer. Kontakt support.',
    },
    certificate_dates: {
      valid_until: 'Gyldigt til {{date}}.',
      expires_on: 'Udløber den {{date}}.',
      expired_on: 'Udløb den {{date}}.',
    },
  },
};
